import React from "react";
import logoImg from "../logo.png";

const Logo = ({ className = "h-12 w-auto" }) => (
  <button
    type="button"
    onClick={() => (window.location.href = "/")}
    className="flex items-center gap-3 text-white font-bold text-xl select-none focus:outline-none"
    aria-label="RapidRates Home"
  >
    <div className="flex items-center gap-3">
      <img src={logoImg} alt="RapidRates.io" className="h-10 w-auto rounded-lg" />
    </div>
  </button>
);

export default Logo;
